<template>
  <div
    class="bg-white"
    :style="{ minHeight: `${height + 50}px` }"
  >
    <div
      v-if="isInitialLoading"
      class="flex items-center justify-center h-[80vh] bg-white"
    >
      <div class="text-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F95031] mx-auto mb-2" />
      </div>
    </div>
    <iframe
      v-show="!isInitialLoading"
      ref="ksgciframe"
      :key="iframeKey"
      frameborder="1"
      :height="height + 50"
      width="100%"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
      @load="handleIframeLoad"
    />
    <router-view />
    <ModalAddProduct
      ref="modalAddProduct"
      @product-created="handleProductCreated"
    />
    <ModalSubmitProduct
      ref="modalSubmitProduct"
      @submit-product="handleSubmitProduct"
    />
  </div>
</template>

<script>
import ModalAddProduct from './detail/ModalAddProduct.vue'
import ModalSubmitProduct from './detail/ModalSubmitProduct.vue'

/**
 * Komponen iframe pencarian gudang dengan navigasi hybrid:
 * - Internal: navigasi dari dalam iframe (tidak rerender)
 * - Eksternal: navigasi dari Vue Router (rerender iframe)
 */
export default {
  components: {
    ModalAddProduct,
    ModalSubmitProduct,
  },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      key: null,
      userId: null,
      password: null,
      pin: null,
      iframeSrc: `${this.VUE_APP_BASE_AUTH_MODULE}/kompack/cari-gudang`,
      iframeKey: 0,
      navigationInProgress: false,
      isInternalNavigation: false,
      isInitialLoading: true,
    }
  },
  watch: {
    /**
     * Watcher untuk navigasi eksternal - update iframe src dan force rerender.
     * Internal iframe sudah handle navigasinya sendiri, jadi tidak perlu rerender
     */
    $route: {
      handler(to, from) {
        if (!this.isInternalNavigation) {
          this.updateIframeSrc()
          this.iframeKey += 1
        }
        this.isInternalNavigation = false
      },
      immediate: false,
    },
  },
  mounted() {
    this.updateIframeSrc()
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    updateIframeSrc() {
      const newSrc = this.getIframeSrcForRoute()
      if (this.iframeSrc !== newSrc) {
        this.iframeSrc = newSrc
      }
    },

    getIframeSrcForRoute() {
      if (this.$route.name === 'detail-gudang-search') {
        return `${process.env.VUE_APP_BASE_AUTH_MODULE}/kompack/cari-gudang/${this.$route.params.id}?wid=${this.$route.query.wid}`
      }
      if (this.$route.name === 'cek-biaya-fulfillment') {
        return `${process.env.VUE_APP_BASE_AUTH_MODULE}/kompack/cari-gudang/${this.$route.params.id}/cek-biaya-fulfillment?wid=${this.$route.query.wid}`
      }
      return `${process.env.VUE_APP_BASE_AUTH_MODULE}/kompack/cari-gudang`
    },

    async navigateToRoute(targetRoute) {
      if (this.navigationInProgress) {
        return
      }

      if (this.$route.path !== targetRoute) {
        this.navigationInProgress = true
        await this.$router.push(targetRoute)
        this.navigationInProgress = false
      }
    },

    watchIframe(event) {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type,
          data,
        } = event.data

        if (type === 'GO_TO_DETAIL_WAREHOUSE') {
          this.isInternalNavigation = true
          const targetRoute = `/search-gudang/detail/${data.mitraId}?wid=${data.warehouseId}`
          this.navigateToRoute(targetRoute)
        }

        if (type === 'GO_BACK_FROM_DETAIL_CARI_GUDANG') {
          this.isInternalNavigation = true
          this.navigateToRoute('/search-gudang')
        }

        if (type === 'GT_SP') {
          this.isInternalNavigation = true
          this.navigateToRoute(`/tambah-produk-gudang-kompack/${data.mitraId}?wid=${data.warehouseId}`)
        }

        if (type === 'SUCCESS_SP') {
          this.$refs.modalSubmitProduct.show({
            warehouseId: data.warehouseId,
            mitraId: data.mitraId,
          })
        }

        if (type === 'GO_TO_CHECK_FULFILLMENT_COST') {
          this.isInternalNavigation = true
          const targetRoute = `/search-gudang/detail/${data.mitraId}/cek-biaya-fulfillment?wid=${data.warehouseId}`
          this.navigateToRoute(targetRoute)
        }

        if (type === 'GO_BACK_FROM_CEK_BIAYA_FULFILLMENT') {
          this.isInternalNavigation = true
          this.navigateToRoute(`/search-gudang/detail/${data.mitraId}?wid=${data.warehouseId}`)
        }

        if (type === 'ADD_PRODUCT') {
          this.$refs.modalAddProduct.show()
        }

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }
      }
    },
    handleProductCreated() {
      const message = {
        type: 'REFETCH_PRODUCT',
      }
      this.$refs.ksgciframe.contentWindow.postMessage(message, '*')
    },

    navigateFromExternal(targetRoute) {
      this.isInternalNavigation = false
      this.navigateToRoute(targetRoute)
    },

    handleIframeLoad() {
      this.isInitialLoading = false
    },

    handleSubmitProduct({ warehouseId, mitraId }) {
      this.isInternalNavigation = true
      this.$refs.modalSubmitProduct.hide()
      this.navigateToRoute(`/tambah-produk-gudang-kompack/${mitraId}?wid=${warehouseId}`)
    },
  },
}
</script>
